import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  { href: "#portfolio", label: "Portfolio" },
  { href: "#faq", label: "FAQ" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-cream/85 backdrop-blur-xl border-b border-espresso/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-baseline gap-2 group">
          <span className={`font-serif text-2xl tracking-tight ${scrolled ? "text-espresso" : "text-cream"}`}>AKT</span>
          <span className={`text-[10px] tracking-[0.3em] uppercase ${scrolled ? "text-taupe" : "text-cream/70"}`}>Global Enterprises</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`text-xs uppercase tracking-[0.2em] link-underline ${scrolled ? "text-espresso" : "text-cream"}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#about"
          data-testid="nav-cta"
          className={`hidden md:inline-block px-6 py-3 text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${
            scrolled
              ? "bg-espresso text-cream hover:bg-brass"
              : "bg-cream text-espresso hover:bg-brass hover:text-cream"
          }`}
        >
          Discover More
        </a>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden ${scrolled ? "text-espresso" : "text-cream"}`}
        >
          {open ? <X strokeWidth={1.25} /> : <Menu strokeWidth={1.25} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-cream border-t border-espresso/10 px-6 py-6" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-espresso text-sm uppercase tracking-[0.2em]"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="bg-espresso text-cream px-6 py-3 text-xs uppercase tracking-[0.2em] w-fit"
              data-testid="nav-mobile-cta"
            >
              List Your Property
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
